var render = function render(){var _vm=this,_c=_vm._self._c;return _c('esg-base-chart',[_c('apex-chart',{ref:"chart",attrs:{"type":"donut","height":"300","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }